import { Avatar, AvatarImage, AvatarFallback } from '../ui/avatar';

interface CompletedByAvatarsUser {
  name: string;
  avatar_small_url?: string;
}

interface CompletedByAvatarsProps {
  users: CompletedByAvatarsUser[];
  totalCount: number;
  maxVisible?: number;
}

export function CompletedByAvatars({ users, totalCount, maxVisible = 3 }: CompletedByAvatarsProps) {
  if (totalCount === 0) return null;

  const visibleUsers = users.slice(0, maxVisible);
  const overflow = totalCount - maxVisible;

  return (
    <div className="flex -space-x-2">
      {visibleUsers.map((user, index) => (
        <Avatar key={index} className="w-8 h-8 ring-2 ring-background">
          <AvatarImage src={user.avatar_small_url} alt={user.name} />
          <AvatarFallback>{user.name.charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
      ))}
      {overflow > 0 && (
        <div className="w-8 h-8 ring-2 ring-background rounded-full bg-muted border flex items-center justify-center text-xs font-medium text-muted-foreground">
          +{overflow}
        </div>
      )}
    </div>
  );
}
